import React, { useState } from 'react';
import { authAPI } from '../services/api';
import useAuthStore from '../store/authStore';
import { toast } from 'sonner';
import './ResetPasswordModal.css';

const ResetPasswordModal = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const completeFirstLogin = useAuthStore(state => state.completeFirstLogin);
    const logout = useAuthStore(state => state.logout);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError('New passwords do not match');
            return;
        }

        if (newPassword.length < 6) {
            setError('Password must be at least 6 characters long');
            return;
        }

        // Check for complexity (uppercase, lowercase, number)
        if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(newPassword)) {
            setError('Password must contain uppercase, lowercase, and a number');
            return;
        }

        setLoading(true);
        try {
            await authAPI.changePassword({ currentPassword, newPassword });
            completeFirstLogin();
            toast.success('Password updated successfully! Welcome to TaskManager.');
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="reset-modal-overlay">
            <div className="reset-modal-card">
                <div className="reset-modal-header">
                    <h2>Security Reset Required</h2>
                    <p>This is your first login. For your security, you must change your initial password before proceeding.</p>
                </div>

                <form onSubmit={handleSubmit} className="reset-modal-form">
                    {error && <div className="reset-error-alert">{error}</div>}

                    <div className="reset-form-group">
                        <label>Current Password</label>
                        <input
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            placeholder="Enter current password"
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="reset-form-group">
                        <label>New Password</label>
                        <input
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Minimum 6 characters"
                            required
                            disabled={loading}
                        />
                        <span className="password-hint">Must include uppercase, lowercase, and a number</span>
                    </div>

                    <div className="reset-form-group">
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Repeat new password"
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="reset-modal-actions">
                        <button
                            type="button"
                            className="btn-reset-logout"
                            onClick={logout}
                            disabled={loading}
                        >
                            Cancel & Logout
                        </button>
                        <button
                            type="submit"
                            className="btn-reset-submit"
                            disabled={loading}
                        >
                            {loading ? 'Updating...' : 'Update Password'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ResetPasswordModal;
